import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PaymentsPage } from "@/features/payments/PaymentsPage";

const search = z.object({
  status: z.enum(["all", "succeeded", "pending", "failed", "refunded", "partially-refunded"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/payments/")({
  validateSearch: search,
  component: () => <PaymentsPage search={Route.useSearch()} />,
});
